import {NFormTable} from "src/components/Shared/NewForms/NFormTable";
import {NFIntInput} from "src/components/Shared/NewForms/NFIntInput";
import {useTranslation} from "react-i18next";
import {NFLookupInput} from "src/components/Shared/NewForms/NFLookupInput";
import { EnumHelper } from "src/helpers/EnumHelper";
import {NFLookupVendorInvoice} from "src/components/Shared/NewForms/NFLookupVendorInvoice";
import {NFPlainNumber} from "src/components/Shared/NewForms/NFPlainNumber";
import {NFPlainText} from "src/components/Shared/NewForms/NFPlainText";

export const DistributionOfLandedCostsVendorInvoices = () => {
    const tableName = "vendorInvoices";
    const {t} = useTranslation();

    return (
        <>
            <NFormTable fieldArray={tableName}>
                <NFLookupVendorInvoice
                    modelField={"vendorInvoiceModel"}
                    fieldName={"vendorInvoiceId"}
                    title={t("VendorInvoice")}
                />
                {/*<NFLookupInput title={t("Rule")} fieldName={"distributionRule"}*/}
                {/*               items={EnumHelper.getDistributionOfLandingCostsRuleEnum(t)}/>*/}
                {/*<NFLookupCurrency*/}
                {/*    fieldName={"currencyId"}*/}
                {/*    title={t("Currency")}*/}
                {/*/>*/}
                {/*<NFPlainText fieldName={}*/}
                <NFPlainNumber
                    fieldName={"totalAmount"}
                    title={t("Amount")}
                    width={100}
                />
            </NFormTable>
        </>
    );
};
